const clinicsActionTypes = {
  addClinic: 'clinics/addClinic',
};

export default clinicsActionTypes;
